export const darkBlue = "#717fe0"
